import { createSlice } from '@reduxjs/toolkit';

// Holds the request data fields that the framework's `state.requestData`
// (populated by ws-scripts) does not expose. Reading these from
// `useRequestData()` would return undefined, so we capture them on the server
// during SSR and surface them to the client via this slice.
const initialState = {
	siteId: '',
	pageAlias: '',
	pageId: ''
};

const moreRequestDataSlice = createSlice({
	name: 'moreRequestData',
	initialState,
	reducers: {
		setMoreRequestData: (state, action) => {
			return typeof action.payload === 'object' && action.payload !== null
				? { ...state, ...action.payload }
				: state;
		}
	}
});

export const { setMoreRequestData } = moreRequestDataSlice.actions;
export default moreRequestDataSlice.reducer;
